import {parse, stringify} from 'query-string';
import {env} from './env';

export const routerUtil = {
  gotoLogin(pathname: string, otherParams?: Record<string, any>) {
    const query = genRedirectTarget();
    const params = {...query, ...(otherParams || {})};
    if (env.isLocal) {
      const proxyEnv = (import.meta.env?.VITE_DEV_HOST || '').replace(/\.?(phemex|cmexpro)\.com/, '');
      Object.assign(params, {
        proxyEnv,
      });
    }
    let url = [pathname, '?', stringify(params)].join('');
    window.location.assign(url);
  },
  gotoRegister(pathname: string) {
    const query = genRedirectTarget();
    let url = [pathname, '?', stringify(query)].join('');
    window.location.assign(url);
  },
};

function genRedirectTarget(customTarget?: string) {
  const o = parse(location.search);
  let target = '';
  if (customTarget) {
    target = customTarget;
  } else if (o?.action?.toLowerCase() === 'target' && o?.target) {
    target = o?.target as string;
  } else {
    target = location.href;
  }

  return {
    ...o,
    target,
    action: 'Target',
  };
}
